export class SD_TreeModel {
  public id?: number | null;
  public pkId?: number | null;
  public templateId?: number | null;
  public uniqueId?: string | null;
  public name?: string | null;
  public isSubElement: boolean;
  public children: SD_TreeModel[];

  constructor(){
    this.children = [];
  }
}
